import React, { useState, useRef, useLayoutEffect, useContext } from "react";
import { callApi, serializeObject } from "bodycodi/cmap/app/js/common";
import Condition from "bodycodi/cmap/app/components/cmap3010/condition";
import MemberList from "bodycodi/cmap/app/components/common/MemberList";
import { observerType } from "bodycodi/cmap/app/components/common/useObserver";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";
import MemberSearchPop from "bodycodi/cmap/app/components/cmap3010/memberSearchPop";
import { Members } from "bodycodi/cmap/app/type";
import {
  DispatchContext as HomeDispatchContext,
  StateContext,
} from "bodycodi/cmap/app/components/cmap2010/home";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

export interface State extends observerType {
  tabName: "APPOINTMENT" | "CHARGE" | "ENTRANCE";
  isDone: boolean;
  isScrollEnd: boolean;
  isBan: boolean;
}

const MemberMngt = () => {
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);
  const { state: stateContext } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);
  const { seqPartner, seqPartnerBranch, seqPartnerCoach } = useSelector(
    (state: RootState) => state.partner
  );
  const form = useRef<HTMLDivElement>(null);
  const [members, setMembers] = useState<Members>({
    appointmentMemberTotalCount: 0,
    chargeMemberTotalCount: 0,
    entranceMemberTotalCount: 0,
    memberList: [],
  });
  const [state, setState] = useState<State>({
    tabName: "APPOINTMENT",
    pageNo: 0,
    listSize: 10,
    loading: false,
    first: true,
    isDone: false,
    isScrollEnd: false,
    isBan: false,
  });
  const { tabName, pageNo, listSize } = state;

  useLayoutEffect(() => {
    fetchMembers("fetch");
  }, [seqPartner, seqPartnerBranch, seqPartnerCoach, tabName]);

  const fetchMembers = (type: string) => {
    setState((previousValue: State) => ({
      ...previousValue,
      loading: true,
    }));
    const data: any = serializeObject({ element: form.current });
    callApi(
      "/members",
      {
        seqPartner: seqPartner,
        seqPartnerBranch: seqPartnerBranch,
        seqPartnerCoach: seqPartnerCoach,
        memberListType: tabName,
        keyword: data.name,
        pageNo: pageNo,
        rowAmt: listSize,
      },
      "GET"
    )
      .then((res) => {
        if (type === "add") {
          setMembers((previousValue: Members) => ({
            ...previousValue,
            memberList: previousValue.memberList.concat(res.memberList),
          }));
        } else {
          setMembers(res);
        }
        if (res.memberList.length < listSize) {
          setState((previousValue: State) => ({
            ...previousValue,
            pageNo: 0,
            isDone: true,
            isScrollEnd: true,
          }));
        } else {
          setState((previousValue: State) => ({
            ...previousValue,
            pageNo: previousValue.pageNo + previousValue.listSize,
            isDone: false,
          }));
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setState((previousValue: State) => ({
          ...previousValue,
          loading: false,
        }));
      });
  };

  const handleClickTab = (tabName: "APPOINTMENT" | "CHARGE" | "ENTRANCE") => {
    setMembers((previousValue: Members) => ({
      ...previousValue,
      memberList: [],
    }));
    setState((previousValue: State) => ({
      ...previousValue,
      tabName,
      pageNo: 0,
      isDone: false,
      isScrollEnd: false,
    }));
  };
  const handleClickMember = (d: any) => {
    homeDispatch({
      type: "UPDATE",
      data: {
        memberDtlPopData: {
          seqPartner: stateContext.member.seqPartner,
          seqPartnerBranch: stateContext.member.seqPartnerBranch,
          seqMember: d.seqMember,
        },
      },
    });
    dispatch({ type: "POP_UP_OPEN", id: "MEMBER_DTL_POP", open: { memberDtlPop: true } });
  };

  return (
    <div className="member-mngt-wrap" ref={form}>
      <MemberSearchPop from="management" onClickMember={handleClickMember} chooseMemberList={{}} />
      <Condition
        tabName={tabName}
        appointmentMemberTotalCount={members.appointmentMemberTotalCount}
        chargeMemberTotalCount={members.chargeMemberTotalCount}
        entranceMemberTotalCount={members.entranceMemberTotalCount}
        onClickTab={handleClickTab}
      />
      <MemberList
        memberList={members.memberList}
        scrollEnd={state.isScrollEnd}
        loading={state.loading}
        listSize={state.listSize}
        isDone={state.isDone}
        isBan={state.isBan}
        fetchMembers={fetchMembers}
        from="management"
        onClickMember={handleClickMember}
        chooseMemberList={{}}
      />
    </div>
  );
};

export default MemberMngt;
